import React from 'react';
import { MultiLevelModal } from 'elmo-elements';
import { MainModal } from './components/MainModal';
import { useBookingModalState } from './hooks/useBookingModalState';

export const BookingModal = () => {
    const { activeModal, handleCallDeleteModal, handleCallOnCreateConfirmationModal, subModals } =
        useBookingModalState();
    return (
        <MultiLevelModal
            mainModal={
                <MainModal
                    onDeleteClick={handleCallDeleteModal}
                    handleCallOnCreateConfirmationModal={handleCallOnCreateConfirmationModal}
                />
            }
            subModals={subModals}
            active={activeModal}
            useMainModalHeight
        />
    );
};
